<template>
  <div class="content-container">
    <title-with-breadcrumbs
      title="Wishlisht"
      class="mb-regular"
    ></title-with-breadcrumbs>
    <div class="flex">
      <template
        v-if="wishlist && wishlist.products && wishlist.products.length"
      >
        <div
          v-for="product in getCountedSortedProductsInWishlist"
          :key="product.id"
          class="product-card"
        >
          <wishlist-row :product="product"></wishlist-row>
        </div>
      </template>
      <template v-else>
        {{ "wishlist.titles.no_products" | translate }}
      </template>
    </div>
  </div>
</template>

<script>
import {
  wishlistMethods,
  cartMethods,
  productImageResizer
} from "../../mixins";
import TitleWithBreadcrumbs from "../atoms/title-with-breadcrumbs.vue";
import WishlistRow from "../molecules/wishlist-row.vue";
export default {
  name: "wishlist",
  mixins: [wishlistMethods, cartMethods, productImageResizer],
  components: { WishlistRow, TitleWithBreadcrumbs }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.content-container {
  background-color: $brand-gray-light;
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

h1 {
  text-align: center;
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.flex {
  flex-wrap: wrap;
  margin: 0 -0.5rem;
}

.product-card {
  width: 50%;
  margin-bottom: 1.5rem;
  padding: 0.5rem;

  @media (min-width: $breakpoint-md) {
    width: 33.3%;
  }

  @media (min-width: $breakpoint-lg) {
    width: 25%;
  }
}
</style>
